/**
 * DividerWidget Component
 *
 * Renders a horizontal or vertical line divider for visual separation.
 * Supports selection state for editor interaction.
 */

import React from 'react';
import { DividerWidgetProps } from './types';
import { DIVIDER_DEFAULT_CONFIG } from '../../config/widgetDefaults';

export const DividerWidget = ({
  config,
  isSelected,
  onSelect,
}: DividerWidgetProps) => {
  // Merge provided config with defaults
  const mergedConfig = {
    ...DIVIDER_DEFAULT_CONFIG,
    ...config,
  };

  const {
    orientation,
    style,
    thickness,
    color,
    marginTop,
    marginBottom,
    width,
  } = mergedConfig;

  const isHorizontal = orientation === 'horizontal';

  // Build inline styles for the divider line
  const dividerStyle: React.CSSProperties = {
    backgroundColor: style === 'solid' ? color : 'transparent',
    borderStyle: style,
    borderColor: color,
    borderWidth: style === 'solid' ? 0 : thickness,
    ...(isHorizontal
      ? {
          width,
          height: style === 'solid' ? thickness : 0,
          marginTop,
          marginBottom,
        }
      : {
          height: '100%',
          width: style === 'solid' ? thickness : 0,
          marginLeft: marginTop,
          marginRight: marginBottom,
        }),
  };

  return (
    <div data-testid="widgets-dividerwidget-div-1"
      onClick={(e) => {
        e.stopPropagation();
        onSelect();
      }}
      className={`tw-w-full tw-cursor-pointer tw-transition-all ${
        isSelected ? 'tw-ring-2 tw-ring-accent tw-ring-offset-2' : ''
      }`}
      role="separator"
      aria-orientation={orientation}
    >
      <div
        style={dividerStyle}
        className={isHorizontal ? 'tw-w-full' : 'tw-h-full'}
      />
    </div>
  );
};

export default DividerWidget;
